
import { defineComponent, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import Residents from '@/components/Residents.vue';

export default defineComponent({
  name: 'Location',

  props: {
    name: {
      type: String,
      required: true,
    },
  },
  components: { Residents },

  setup() {
    const residents = ref([] as any);
    const characters = ref([] as any);
    const route = useRoute();

    const getResidents = async () => {
      const res = await fetch(
        `https://rickandmortyapi.com/api/location/${route.params.id}`
      )
        .then((res) => res.json())
        .then((data) => {
          const ids = data.residents.map((url: string) =>
            Number(
              url.replace('https://rickandmortyapi.com/api/character/', '')
            )
          );

          return fetch(
            `https://rickandmortyapi.com/api/character/${ids.join(',')}`
          );
        })
        .then((res) => res.json())
        .then((data) => {
          characters.value = Array.isArray(data) ? data : [data];
        });

      return characters.value;
    };

    onMounted(getResidents);

    return {
      characters,
    };
  },
});
